import { Locale } from '@repo/utils'
import sanitize from 'sanitize-html'

import { IQuoteProvisionInputProps } from '../CreateOrUpdateQuoteProvisionModal'
import {
  CurrencyAreaOutputDto,
  CurrencyEnum,
} from '../../../../../../../../lib/graphql'
import { decimalPrice, percentage } from '../../../../../../../../utils'
import {
  divideByFactor,
  multiplyByFactor,
} from '../../../../../../../../utils/prices'

export const getVatRateOptions = ({
  currencyArea,
  locale,
}: {
  currencyArea: CurrencyAreaOutputDto
  locale: Locale
}) => {
  const vatRates =
    currencyArea?.vatRates.map((vatRate) => ({
      label: percentage({ rate: vatRate, locale }),
      value: [vatRate],
    })) ?? []
  const multiVatRates =
    currencyArea?.multiVatRates?.map((multiVatRate) => {
      const label = multiVatRate
        .map((vatRate, index) => {
          if (index === multiVatRate.length - 1) {
            return percentage({ rate: vatRate, locale })
          }
          return divideByFactor(vatRate)
        })
        .join(' - ')

      return {
        label,
        value: multiVatRate,
      }
    }) ?? []

  return [...vatRates, ...multiVatRates]
}

export const calculateUnitPrice = ({
  totalPrice,
  quantity,
}: {
  totalPrice?: number
  quantity?: number
}) => {
  if (!quantity || !totalPrice) {
    return '-'
  }
  const unitPrice = totalPrice / quantity
  return decimalPrice(multiplyByFactor(unitPrice))
}

export const calculateTotalPriceFooter = ({
  isPriceWithVat,
  inputTotalPrice,
  inputUnitPrice,
  inputQuantity,
  currency,
}: {
  isPriceWithVat: boolean
  inputTotalPrice?: number
  inputUnitPrice?: number
  inputQuantity?: number
  currency: CurrencyEnum
}) => {
  if (!inputUnitPrice || !inputQuantity || !inputTotalPrice) {
    return { totalPriceTTC: '-', totalPriceHT: '-' }
  }

  let totalPriceTTC = '-'
  let totalPriceHT = '-'
  if (!isPriceWithVat && inputTotalPrice) {
    totalPriceTTC = decimalPrice(multiplyByFactor(inputTotalPrice), {
      currency,
    })
    totalPriceHT = decimalPrice(
      multiplyByFactor(inputUnitPrice * inputQuantity),
      { currency },
    )
  } else if (isPriceWithVat && inputTotalPrice) {
    totalPriceHT = decimalPrice(multiplyByFactor(inputTotalPrice), { currency })
    totalPriceTTC = decimalPrice(
      multiplyByFactor(inputUnitPrice * inputQuantity),
      { currency },
    )
  }

  return { totalPriceTTC, totalPriceHT }
}

export const getDefaultValues = (
  defaultValues: IQuoteProvisionInputProps | undefined,
) => {
  if (!defaultValues) {
    return undefined
  }

  const formattedDescription = defaultValues.description.replace(/<\/p>/g, '\n')

  return {
    ...defaultValues,
    description: sanitize(formattedDescription, { allowedTags: [] }),
  }
}
